module.exports = __webpack_public_path__ + "img/20171.c07f747a.png";